export const sliderData = [
  {
    image:
      "https://images.pexels.com/photos/577769/pexels-photo-577769.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    heading: "Fully Functioning Amazon Clone",
    desc: "This is not the main amazon app but behaves like it, with a FULLY FUNCTIONG E-COMMERCE FUNCTIONALLITY",
  },

  {
    image:
      "https://images.pexels.com/photos/325153/pexels-photo-325153.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    heading: "Main Functionality",
    desc: "It has a back end server that remembers your orders and activities when signed in, *Hence it has a data storage for each users signed in ..........A COMPLETE E-COMMERCE FUNCTIONALITY hence this app can make REALTIME payment just like the main if real-time ones are required",
  },

  {
    image: "https://images.pexels.com/photos/3989775/pexels-photo-3989775.jpeg",
    heading: "Sub Functionality (1)",
    desc: "Presently it has been configured to test mode hence REAL AMOUNTS ARE NOT CHARGED AND HENCE REAL CARD DETAILS ARE NOT GIVEN [TEST CARD NUMBER:- 424242424.......(just continue typing 4242 until the input space gets used up)] and more, feel free to exlore the app",
  },
  {
    image:
      "https://images.pexels.com/photos/163696/toy-car-toy-box-mini-163696.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    heading: "Sub Functionality (2)",
    desc: "GEOLOCATION........ This app knows your location using your device latitude and longitude (written at the header)",
  },
];
